/**
 * A Mo (AI-asszisztens) belépési pontjai — a topbar csillag-gombja, a mobil FAB „Kérdezd Mo-t" eleme és a panel —
 * IDEIGLENESEN REJTVE (user-döntés, Ilcsa #106): a Mo-szolgáltatás még nincs kész (HTTP 502), a bekötése
 * follow-up feladat. Bekapcsolás: `true`. A kód (panel, SSE, BFF-végpont) érintetlen.
 */
// `boolean` (nem a `false` literál-típus): kapcsoló, a hívók feltételei nem „mindig hamis"-ak
export const MO_ENABLED = false as boolean;
